import { marked } from 'marked'

marked.setOptions({
  breaks: true,
  gfm: true
})

const MD_PATTERN =
  /(?:^|\n)\s{0,3}(?:#{1,6}\s|[-*+]\s+\S|\d+\.\s+\S|>\s)|\*\*[^*\n]+\*\*|__[^_\n]+__|`[^`\n]+`|```[\s\S]*?```|\[[^\]\n]+\]\([^)\n]+\)/

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/**
 * 判断笔记内容是否包含常见 Markdown 语法
 * @param {string} content
 */
export function looksLikeMarkdown(content) {
  if (content == null) return false
  const text = String(content).trim()
  if (!text) return false
  return MD_PATTERN.test(text)
}

/**
 * 渲染笔记内容：Markdown 格式化展示，纯文本保持换行与原样显示
 * @param {string} content
 * @returns {string}
 */
export function renderNoteContent(content) {
  const text = content != null ? String(content) : ''
  if (!text.trim()) return ''

  if (!looksLikeMarkdown(text)) {
    return `<div class="note-plain-text">${escapeHtml(text).replace(/\n/g, '<br>')}</div>`
  }

  return marked.parse(text)
}
